export default __webpack_public_path__ + "static/media/pic-3.1f2324d4.jpg";